import type { KeyboardEvent, MouseEvent, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import Popover from '@fastnorth/kraken/components/popover';
import { Button } from '@fastnorth/kraken/components/button';
import { Div } from '@fastnorth/kraken/components/layout';
import { Paragraph } from '@fastnorth/kraken/components/typography';

const stopCardActivation = (event: MouseEvent | KeyboardEvent): void => {
  event.stopPropagation();
};

const RaceSummaryOnCourseHelp = (): ReactElement => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.event_progress_v2' });

  return (
    <Div className="ml-3 inline-flex shrink-0 items-center self-center">
      <Popover
        trigger={
          <Button
            aria-label={t('on_course_glossary_trigger_aria')}
            className="!size-6 min-h-0 shrink-0 rounded-full bg-border p-0"
            onClick={stopCardActivation}
            onKeyDown={stopCardActivation}
            size="icon-sm"
            type="button"
            variant="ghost">
            <span
              aria-hidden
              className="text-[11px] font-semibold leading-none text-muted-foreground">
              ?
            </span>
          </Button>
        }>
        <Paragraph className="text-xs leading-normal">{t('on_course_glossary_body')}</Paragraph>
      </Popover>
    </Div>
  );
};

export default RaceSummaryOnCourseHelp;
